module.exports = __webpack_public_path__ + "static/media/mvp-speech-sound.d19dc018.mp3";